import React from "react";
import ContentSections from "./sections/ContentSections";
import ServiceSections from "./sections/ServiceSections";
import SupportSections from "./sections/SupportSections";

const HowItWorksContent = () => {
  return (
    <div id="how-content" className="backdrop-blur">
      <ContentSections />
      <ServiceSections />
      <SupportSections />
    </div>
  );
};

export default HowItWorksContent;
